<template>
    <h2>Cerca la moto</h2>
    <div class="inline-block w-full mb-[20px]">
        <label class="font-light block mb-[5px]">Pubblicazione Eurotax del:</label>
        <select :disabled="isSelectDataDisabled" :class="{ 'disabled': isSelectDataDisabled }"
            v-model="dataPubblicazione" @change="setDataPubblicazione">
            <option v-for="(pubb, index) in periodi" :key="index" :value="`${pubb?.mese}/${pubb?.anno}`">
                {{ pubb?.descrizione }}
            </option>
        </select>
    </div>

    <div class="h-[1px] bg-[#e96932] block w-full relative text-center mb-[20px]"></div>

    <Popup v-if="isNoDataPopupOpen" title="Veicolo non trovato" :data="datiVeicoloNonDisponibile"
        @close="isNoDataPopupOpen = false" />

    <div class="flex justify-between flex-wrap">
        <div v-if="mainStore?.abbonato?.ricercaTarga?.includes('Moto')"
            class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label>Targa:</label>
            <input type="text" v-model="targa" placeholder="Targa" @input="codiceMnet = ''" />
            <div v-if="isLicensePlatesVisible && vehicleSearched?.versioni?.length > 0"
                class="bg-white block border border-[#ccc] border-t-0 w-full rounded-[10px] z-[1] max-h-[200px] overflow-auto shadow-[0_3px_6px_rgba(0,0,0,0.16)]">
                <ul class="list-none block w-full text-sm m-0 p-0">
                    <li v-for="(item, index) in vehicleSearched.versioni" :key="index"
                        class="list-none block w-full cursor-pointer m-0 p-0 hover:bg-[#ccc]"
                        @click="saveVehicle(item)">
                        <div class="block w-full text-black text-left border border-top-[#ccc] m-0 py-[8px] px-[15px]">
                            {{ item?.marca?.nome }} {{ item?.versione }}<br>{{ format(item?.da, "YYYY-MM-DD", "MM/YYYY")
                            }} - {{ format(item?.a, "YYYY-MM-DD", "MM/YYYY") }}
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label>Codice Mnet o Eurotax:</label>
            <input type="text" v-model="codiceMnet" placeholder="Codice Mnet o Eurotax" @input="targa = ''" />
            <div v-if="isEurotaxCodesListVisible && vehicleSearched?.versioni?.length > 0"
                class="bg-white block border border-[#ccc] border-t-0 w-full rounded-[10px] z-[1] max-h-[200px] overflow-auto shadow-[0_3px_6px_rgba(0,0,0,0.16)]">
                <ul class="list-none block w-full text-sm m-0 p-0">
                    <li v-for="(item, index) in vehicleSearched.versioni" :key="index"
                        class="list-none block w-full cursor-pointer m-0 p-0 hover:bg-[#ccc]"
                        @click="saveVehicle(item)">
                        <div class="block w-full text-black text-left border border-top-[#ccc] m-0 py-[8px] px-[15px]">
                            {{ item?.marca?.nome }} {{ item?.versione }}<br>{{ format(item?.da, "YYYY-MM-DD", "MM/YYYY")
                            }} - {{ format(item?.a, "YYYY-MM-DD", "MM/YYYY") }}
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>


    <div class="flex justify-end mt-[10px] sm:mt-0">
        <button class="button sm:my-[20px] p-[15px] sm:p-[20px]" @click="searchVehicle">Ricerca</button>
    </div>

    <div class="block w-full relative text-center my-[20px]">
        <div class="absolute top-[50%] w-full h-[1px] bg-[#e96932] block"></div>
        <span class="bg-[#f8f9fa] relative px-[20px]">Oppure</span>
    </div>

    <div class="flex justify-between flex-wrap mb-[20px]" id="selection">
        <div v-if="isImmatricolazioneEstera && targaEstero" class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                Targa Estera
            </label>
            <input type="text" class="disabled bg-[#fff]" disabled v-model="targaEstero" />
        </div>
        <div v-if="isImmatricolazioneEstera && statoEstero" class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                Stato Estero
            </label>
            <input type="text" class="disabled bg-[#fff]" disabled v-model="statoEstero" />
        </div>
        <div v-if="isImmatricolazioneEstera && dataImmatricolazioneEstero" class="inline-block w-full mb-[20px]">
            <label class="font-bold block mb-[5px]">
                Data immatricolazione Estera
            </label>
            <input type="text" class="disabled bg-[#fff]" disabled v-model="dataImmatricolazioneEstero" />
        </div>
        <div class="inline-block w-full md:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                <span class="inline-block text-center font-light w-[24px] h-[24px] mr-[3px]">1 -</span>Marca
            </label>
            <select :disabled="isSelectMarcaDisabled" :class="{ 'disabled': isSelectMarcaDisabled }" v-model="marca"
                @change="setMarca">
                <option value="">Seleziona</option>
                <option v-for="(marca, index) in marche" :key="index" :value="marca?.acronimo">
                    {{ marca?.nome }}
                </option>
            </select>
        </div>
        <div class="hidden md:inline-block sm:w-[48%] mb-[20px]"></div>
        <div class="inline-block w-full md:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                <span class="inline-block text-center font-light w-[24px] h-[24px] mr-[3px]">2 -</span>Anno prima
                immatricolazione
            </label>
            <select :disabled="isSelectAnnoDisabled" :class="{ 'disabled': isSelectAnnoDisabled }" v-model="anno"
                @change="setAnno">
                <option value="">Seleziona</option>
                <option v-for="(anno, index) in anni" :key="index" :value="anno">
                    {{ anno }}
                </option>
            </select>
        </div>
        <div class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                <span class="inline-block text-center font-light w-[24px] h-[24px] mr-[3px]">3 -</span>Mese prima
                immatricolazione
            </label>
            <select :disabled="isSelectMeseDisabled" :class="{ 'disabled': isSelectMeseDisabled }" v-model="mese"
                @change="setMese">
                <option value="">Seleziona</option>
                <option v-for="(mese, index) in mesi" :key="index" :value="mese">
                    {{ mese }}
                </option>
            </select>
        </div>
        <div class="inline-block w-full mb-[20px]">
            <label class="font-bold block mb-[5px]">
                <span class="inline-block text-center font-light w-[24px] h-[24px] mr-[3px]">4 -</span>Modello /
                Versione
            </label>
            <div class="w-full overflow-auto">
                <select :disabled="isSelectVersioneDisabled" :class="{ 'disabled': isSelectVersioneDisabled }"
                    v-model="versione" @change="setVersione" style="width: auto; min-width: 100%">
                    <option value="">Seleziona</option>
                    <option v-for="(versione, index) in versioni" :key="index" :value="versione.codiceEurotax">
                        {{ versione?.nome }} ({{ format(versione?.da, "YYYY-MM-DD", "MM/YYYY") }} - {{
                            format(versione?.a, "YYYY-MM-DD", "MM/YYYY") }})
                    </option>
                </select>
            </div>
        </div>
        <div class="inline-block w-full md:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                <span class="inline-block text-center font-light w-[24px] h-[24px] mr-[3px]">5 -</span>Percorrenza km
                media
            </label>
            <input type="text" class="disabled bg-[#fff]" disabled placeholder="Calcolo in corso..."
                v-model="percorrenzaMedia" />
        </div>
        <div class="inline-block w-full md:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                <span class="inline-block text-center font-light w-[24px] h-[24px] mr-[3px]">6 -</span>Percorrenza km
            </label>
            <input type="text" placeholder="Percorrenza km" v-model="percorrenzaChilometrica" />
        </div>
    </div>

    <div v-if="mainStore.abbonato?.adm" class="flex justify-end">
        <button class="button p-[15px] sm:p-[20px]" @click="submit">valutazione</button>
    </div>
</template>

<script>
import axios from 'axios';
import { mainStore } from '../../../store/main';
import formatter from "../../formatter";
import Popup from '../Popup.vue';

export default {
    name: 'RicercaMoto',
    components: { Popup },

    data() {
        return {
            mainStore,
            marche: [],
            periodi: [],
            dataPubblicazione: null,
            targa: null,
            telaio: null,
            codiceMnet: null,
            codiceCostruttore: null,
            anni: [],
            mesi: [],
            versioni: [],
            isSelectMarcaDisabled: true,
            isSelectDataDisabled: true,
            isSelectAnnoDisabled: true,
            isSelectMeseDisabled: true,
            isSelectVersioneDisabled: true,
            isPercorrenzaMediaDisabled: true,
            marca: "",
            anno: "",
            mese: "",
            versione: "",
            percorrenzaMedia: "",
            percorrenzaChilometrica: "",
            valutazione: {},
            perizia: {},
            vehicleSearched: {},
            isSavingMode: false,
            isLicensePlatesVisible: false,
            isEurotaxCodesListVisible: false,
            isNoDataPopupOpen: false,
            datiVeicoloNonDisponibile: {},
            isImmatricolazioneEstera: false,
            targaEstero: "",
            statoEstero: "",
            dataImmatricolazioneEstero: ""
        }
    },

    async created() {
        const loader = this.$loading.show();

        await this.getPeriodoValutazioni();
        if (this.periodi.length > 0) {
            this.dataPubblicazione = `${this.periodi[0]?.mese}/${this.periodi[0]?.anno}`;
            this.setDataPubblicazione();
        }
        await this.getMarche();

        if (this.mainStore?.datiSearchTargaTipoVeicoloSbagliato != {}) {
            this.targa = this.mainStore.datiSearchTargaTipoVeicoloSbagliato?.targa;
            this.vehicleSearched = this.mainStore.datiSearchTargaTipoVeicoloSbagliato;
            this.isLicensePlatesVisible = true;
        }

        loader.hide();
    },

    methods: {
        resetForm() {
            this.marca = "";
            this.isSelectAnnoDisabled = true;
            this.anno = "";
            this.anni = [];
            this.isSelectMeseDisabled = true;
            this.mese = "";
            this.isSelectVersioneDisabled = true;
            this.versione = "";
            this.versioni = [];
            this.percorrenzaChilometrica = "";
            this.percorrenzaMedia = "";
            this.targaEstero = "";
            this.statoEstero = "";
            this.dataImmatricolazioneEstero = "";
            this.isImmatricolazioneEstera = false;
        },
        format(date, initialFormat, finalFormat) {
            if (!date) {
                return null;
            }
            return formatter.formatDate(date, initialFormat, finalFormat);
        },
        async setDataPubblicazione() {
            this.marca = "";
            this.anno = "";
            this.anni = [];
            this.isSelectAnnoDisabled = true;
            this.mese = "";
            this.isSelectMeseDisabled = true;
            this.versione = "";
            this.versioni = [];
            this.isSelectVersioneDisabled = true;
            this.percorrenzaMedia = "";
            this.percorrenzaChilometrica = "";
        },
        async setMarca() {
            const loader = this.$loading.show();

            this.isSavingMode = false;

            this.targa = null;
            this.codiceMnet = null;

            this.anno = "";
            this.mese = "";
            this.isSelectMeseDisabled = true;
            this.versione = "";
            this.versioni = [];
            this.isSelectVersioneDisabled = true;
            this.percorrenzaChilometrica = "";

            this.percorrenzaMedia = "";
            if (!this.marca) {
                this.isSelectAnnoDisabled = true;
            } else {
                this.isSelectAnnoDisabled = true;
                await this.getAnni();
                this.isSelectAnnoDisabled = false;
            }

            loader.hide();
        },
        async setAnno() {
            const loader = this.$loading.show();

            if (this.anno) {
                this.isSelectAnnoDisabled = false;
            }

            if (!this.isSavingMode) {
                this.mese = "";
                this.versione = "";
                this.versioni = [];
                this.isSelectVersioneDisabled = true;

                this.percorrenzaMedia = "";
                if (!this.anno) {
                    this.isSelectMeseDisabled = true;
                } else {
                    this.isSelectMeseDisabled = true;
                    this.getMesi();
                    this.isSelectMeseDisabled = false;
                }
            } else {
                this.isSelectMeseDisabled = false;
            }

            if (this.versione && this.anno && this.mese && this.dataPubblicazione) {
                await this.getPercorrenzaMedia();
            }

            loader.hide();
        },
        async setMese() {
            const loader = this.$loading.show();

            if (this.mese) {
                this.isSelectMeseDisabled = false;
            }

            if (!this.isSavingMode) {
                this.versione = "";

                this.percorrenzaMedia = "";
                if (!this.mese) {
                    this.isSelectVersioneDisabled = true;
                } else {
                    this.isSelectVersioneDisabled = true;
                    await this.getVersioni();
                    this.isSelectVersioneDisabled = false;
                }
            } else {
                this.isSelectVersioneDisabled = false;
            }

            if (this.versione && this.anno && this.mese && this.dataPubblicazione) {
                await this.getPercorrenzaMedia();
            }

            loader.hide();
        },
        async setVersione() {
            const loader = this.$loading.show();

            if (this.versione) {
                this.isSelectVersioneDisabled = false;
                this.percorrenzaMedia = "";
            }

            if (this.versione && this.anno && this.mese && this.dataPubblicazione) {
                await this.getPercorrenzaMedia();
            }

            loader.hide();
        },
        async searchVehicle() {
            this.isLicensePlatesVisible = false;
            this.isEurotaxCodesListVisible = false;

            if (!this.targa && !this.codiceMnet) {
                this.$notify({
                    title: "Attenzione",
                    text: "Inserire una targa o codice Mnet",
                    type: "warn",
                });
                return;
            }

            const loader = this.$loading.show();

            this.resetForm();

            let response = null;
            try {
                if (this.targa) {
                    response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/generali/targa?targa=${this.targa}&costruttore=`);

                    this.isLicensePlatesVisible = true;
                } else {
                    response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/moto/eurotax_mnet?codice_eurotax_mnet=${this.codiceMnet}`);

                    this.isEurotaxCodesListVisible = true;
                }

                if (response.data?.tipoVeicolo && response.data.tipoVeicolo != "DUE_RUOTE") {
                    this.mainStore.datiSearchTargaTipoVeicoloSbagliato = { ...response.data };
                    if (response.data.tipoVeicolo == "AUTOVETTURE") {
                        this.mainStore.type = "auto";
                    } else {
                        this.mainStore.type = "vcom";
                    }
                    this.$router.push("/ricerca-modello");
                }

                if (response.data?.versioni?.length < 1) {
                    this.datiVeicoloNonDisponibile = {
                        targa: response.data?.targa,
                        telaio: response.data?.telaio,
                        tipo: response.data?.tipoVeicolo,
                        codiceMotore: response.data?.codiceMotore,
                        codiceOmologazione: response.data?.codiceOmologazione,
                        dataImmatricolazione: response.data?.dataImmatricolazione,
                        dataUltimaRevisione: response.data?.dataUltimaRevisione,
                        immatricolazioneEstera: response.data?.immatricolazioneEstera,
                        statoEstero: response.data?.statoEstero,
                        targaEstero: response.data?.targaEstero,
                        dataImmatricolazioneEstero: response.data?.dataImmatricolazioneEstero
                    }
                    this.isNoDataPopupOpen = true;
                    loader.hide();
                    return;
                }

                this.vehicleSearched = response?.data;
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nella ricerca del veicolo",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }

            loader.hide();
        },
        async saveVehicle(data) {
            const loader = this.$loading.show();

            this.percorrenzaMedia = "";

            this.isLicensePlatesVisible = false;
            this.isEurotaxCodesListVisible = false;

            if (this.vehicleSearched?.immatricolazioneEstera == "si") {
                this.targaEstero = this.vehicleSearched.targaEstero;
                this.statoEstero = this.vehicleSearched?.statoEstero;
                this.dataImmatricolazioneEstero = this.format(this.vehicleSearched?.dataImmatricolazioneEstero, "YYYY-MM-DD", "DD/MM/YYYY");
                this.isImmatricolazioneEstera = true;
            } else {
                this.targaEstero = "";
                this.statoEstero = "";
                this.dataImmatricolazioneEstero = this.format(this.vehicleSearched?.dataImmatricolazioneEstero, "YYYY-MM-DD", "DD/MM/YYYY");
                this.isImmatricolazioneEstera = false;
            }

            this.isSavingMode = true;
            this.marca = data?.marca?.acronimo;

            this.versioni = [...this.vehicleSearched?.versioni.map(item => {
                let versione = { ...item };
                versione.nome = item?.versione;
                return versione;
            })];

            if (this.versioni?.length == 1) {
                this.versione = this.versioni[0]?.codiceEurotax;
            } else {
                this.versione = data?.codiceEurotax;
            }

            this.telaio = this.vehicleSearched?.telaio;

            this.anni = [];
            this.anno = "";
            this.mesi = [];
            this.mese = "";
            if (this.dataImmatricolazioneEstero) {
                this.anni = [this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "YYYY")];
                this.anno = this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "YYYY");
                this.mesi = [this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "M")];
                this.mese = this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "M");
            } else if (this.vehicleSearched?.dataImmatricolazione) {
                this.anni = [this.format(this.vehicleSearched.dataImmatricolazione, "YYYY-MM-DD", "YYYY")];
                this.anno = this.format(this.vehicleSearched.dataImmatricolazione, "YYYY-MM-DD", "YYYY");
                this.mesi = [this.format(this.vehicleSearched.dataImmatricolazione, "YYYY-MM-DD", "M")];
                this.mese = this.format(this.vehicleSearched.dataImmatricolazione, "YYYY-MM-DD", "M");
            } else {
                if (data?.fineProduzione) {
                    for (let i = data?.inizioProduzione?.split("-")[0]; i <= data?.fineProduzione?.split("-")[0]; i++) {
                        this.anni.unshift(i);
                    }
                } else {
                    for (let i = data?.inizioProduzione?.split("-")[0]; i <= new Date().getFullYear(); i++) {
                        this.anni.unshift(i);
                    }
                }

                this.getMesi();
            }

            if (this.versione && this.anno && this.mese && this.dataPubblicazione) {
                await this.getPercorrenzaMedia();
            }

            this.isSelectAnnoDisabled = false;
            this.isSelectMeseDisabled = false;
            this.isSelectVersioneDisabled = false;

            this.vehicleSearched = {};
            this.mainStore.datiSearchTargaTipoVeicoloSbagliato = {};

            document.getElementById('selection').scrollIntoView({ behavior: 'smooth' });

            loader.hide();
        },
        async submit() {
            if (!this.marca || !this.anno || !this.mese || !this.versione || !this.percorrenzaMedia) {
                this.$notify({
                    title: "Attenzione",
                    text: "Compilare tutti i campi prima di proseguire con la valutazione",
                    type: "warn",
                });
                return;
            }

            if (this.percorrenzaChilometrica != "") {
                const reg = new RegExp(/^\d+$/);
                if (!reg.test(this.percorrenzaChilometrica)) {
                    this.$notify({
                        title: "Attenzione",
                        text: "Percorrenza km non valida: deve essere un valore numerico positivo",
                        type: "warn",
                    });
                    return;
                } else if (parseInt(this.percorrenzaChilometrica) > 0) {
                    this.percorrenzaChilometrica = parseInt(this.percorrenzaChilometrica);
                } else {
                    this.percorrenzaChilometrica = "";
                }
            }

            const loader = this.$loading.show();

            await this.getValutazione();
            await this.getDettagli();

            let perizia = {
                valutazione: this.valutazione?.valore?.valutazione, dettagli: {
                    codiceEurotax: this.dettagli?.modello?.codiceEurotax, nome: this.dettagli?.modello?.allestimento, marca: this.dettagli?.modello?.marca,
                    modelloBreveCarrozzeria: ""
                }
            };

            perizia.annoImmatricolazione = this.anno.toString();
            perizia.meseImmatricolazione = this.mese;
            this.mainStore.perizia = { ...perizia };
            this.mainStore.perizie = [perizia];
            this.mainStore.kmPerizia = this.percorrenzaChilometrica != "" ? this.percorrenzaChilometrica : 0;

            this.$router.push('/perizia');

            loader.hide();
        },
        async getDettagli() {
            try {
                const codiceEurotax = this.vehicleSearched?.codiceEurotax ? this.vehicleSearched.codiceEurotax : this.versione;

                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/moto/dettaglio?codice_eurotax=${codiceEurotax}`);

                this.dettagli = response.data;
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento dei dettagli",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getPeriodoValutazioni() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/moto/valutazione/periodi`);

                this.periodi = response?.data?.periodi;
                if (this.periodi.length > 0) {
                    this.dataPubblicazione = this.periodi[0].pubblicazione;
                }
                this.isSelectDataDisabled = false;
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento delle pubblicazioni Eurotax",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getMarche() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/moto/marche?libro=false`)
                for (const marca in response?.data?.marche) {
                    this.marche.push({ acronimo: response?.data?.marche[marca]?.acronimo, nome: response?.data?.marche[marca]?.nome });
                }

                this.isSelectMarcaDisabled = false;
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nella lista delle marche",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getAnni() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/moto/anni?codice_marca=${this.marca}`);

                this.anni = response?.data?.anni;
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nella lista degli anni",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        getMesi() {
            this.mesi = [];

            try {
                for (let i = 1; i < 13; i++) {
                    this.mesi.push(i);
                }
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento dei mesi",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getVersioni() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/moto/versioni?anno=${this.anno}&libro=false&codice_marca=${this.marca}`);

                this.versioni = [...response.data?.versioni];
                if (this.versioni.length == 1) {
                    this.versione = this.versioni[0]?.codiceEurotax;
                }
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nella lista delle versioni",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getPercorrenzaMedia() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/moto/percorrenza?codice_eurotax=${this.versione}&anno=${this.anno}`
                    + `&mese=${this.mese}&anno_valutazione=${this.format(this.dataPubblicazione, "MM/YYYY", "YYYY")}&mese_valutazione=${this.format(this.dataPubblicazione, "MM/YYYY", "M")}`);

                this.percorrenzaMedia = response.data?.percorrenza ? response.data.percorrenza : "N.D.";
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel calcolo della percorrenza media",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getValutazione() {
            try {
                const response = await axios.post(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/admonline/perizia/moto`, {
                    accessori: [],
                    calcoloValutazione: {
                        annoImmatricolazione: parseInt(this.anno),
                        annoValiditaPerizia: parseInt(this.dataPubblicazione.split('/')[1]),
                        codiceEurotax: this.versione,
                        km: this.percorrenzaChilometrica,
                        meseImmatricolazione: parseInt(this.mese),
                        meseValiditaPerizia: parseInt(this.dataPubblicazione.split('/')[0]),
                        ignoraVariazioneKm: false
                    },
                    cliente: {},
                    configAccessori: null,
                    danni: {},
                    datiAggiuntiviCalcolo: {
                        correzioni: {}
                    },
                    nota: "",
                    personalizzazione: {},
                    riparazioniCarrozzeria: {},
                    riparazioniMeccanica: {},
                    spese: {},
                    superValutazioni: [],
                    veicolo: {
                        dataImmatricolazioneEstero: this.dataImmatricolazioneEstero,
                        targa: this.targa,
                        targaEstero: this.targaEstero,
                        telaio: this.telaio
                    }
                }, { headers: { "content-type": "application/json" } })

                this.valutazione = { ...response.data };
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nella valutazione",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
    },
}
</script>